import { AdjustmentsHorizontalIcon, ChevronDownIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type FiltersToggleProps = WithClassName<{
	isOpen: boolean
	onClick: () => void
}>

export const FiltersToggle = ({ isOpen, className, onClick }: FiltersToggleProps) => {
	const { t } = useTranslation()

	return (
		<button
			type="button"
			aria-expanded={isOpen}
			className={cn(
				'inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-md px-4 text-sm font-medium shadow transition-colors [&>svg]:shrink-0 [&>svg]:stroke-2',
				isOpen
					? 'bg-primary text-primary-foreground hover:bg-primary/90'
					: 'border border-border bg-background text-foreground hover:bg-muted',
				className
			)}
			onClick={onClick}>
			<AdjustmentsHorizontalIcon className="h-4 w-4" />
			{t('Filters')}
			<ChevronDownIcon className={cn('h-3.5 w-3.5 transition-transform', isOpen && 'rotate-180')} />
		</button>
	)
}
